<template>
  <el-dialog v-model="visible" title="阈值与区间设置" width="1140px" :show-close="false" :close-on-click-modal="false">
    <el-table :data="thresholdData" class="mb-3">
      <el-table-column prop="field" label="展示字段"></el-table-column>
      <el-table-column label="不合规阈值" #default="{row}">
        <el-input-number
          v-model="row.non"
          theme="normal"
          :controls="false"
          step-strictly
        ></el-input-number>
      </el-table-column>
      <el-table-column label="严重不合规阈值" #default="{row}">
        <el-input-number
          v-model="row.serious"
          theme="normal"
          :controls="false"
          step-strictly
        ></el-input-number>
      </el-table-column>
      <el-table-column label="区间" #default="{row}">
        <el-input-number
          v-model="row.interval"
          theme="normal"
          :controls="false"
          step-strictly
        ></el-input-number>
      </el-table-column>
    </el-table>

    <template #footer>
      <div class="text-center">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="onConfirm"> 确认 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  emits: ["confirm"],

  props: {
    AssetType: String,
    showFieldOption: Array
  },

  data() {
    return {
      visible: false,
      thresholdData: [],
    }
  },

  computed: {
    project() {
      return this.$route.query.project
    },
  },

  methods: {
    open() {
      this.visible = true;

      this.thresholdData = []
      this.showFieldOption.forEach(field => {
        this.thresholdData.push({
          field,
          non: 0,
          serious: 0,
          interval: 0,
        })
      })

      this.getData()
    },

    async setData() {
      let data = {}
      this.thresholdData.forEach(row => {
        data[row.field] = {
          Threshold: [row.non, row.serious],
          Interval: row.interval
        }
      })

      await axios.post(`memory/static_resource_threshold/`, {
        project: this.project,
        allType: this.AssetType,
        data
      })
    },

    async getData() {
      const {data} = await axios('memory/static_resource_threshold/', {
        params: {
          project: this.project,
          allType: this.AssetType,
        }
      })

      Object.entries(data).forEach(([field, value]) => {
        const index = this.thresholdData.findIndex(item => item.field == field)

        this.thresholdData[index] = {
          field,
          non: value.Threshold?.[0],
          serious: value.Threshold?.[1],
          interval: value.Interval,
        } 
      })
    },

    async onConfirm() {
      await this.setData()
      this.$emit("confirm");
      this.visible = false;
    },
  },
}
</script>

<style scoped>
.el-input-number {
  width: auto;
}
</style>